const fieldsMapper = {
    required: (data) => data?.required,
    dataType: (data) => data?.schema?.type,
    description: (data) => data?.description,
    value: (data) => data?.value
}

export {fieldsMapper}